module.exports = __webpack_public_path__ + "static/media/ironman-mask-2-01.ca7e8117.png";